import PropTypes from "prop-types";

const ToggleSwitch = (props) => {
	const { checked, onChange } = props;

	return (
		<div className="toggle-switch">
			<input
				type="checkbox"
				className="toggle-switch-checkbox"
				name="toggleSwitch"
				id="toggleSwitch"
				defaultChecked={checked}
				onChange={(e) => onChange(e.target.checked)}
			/>
			<label className="toggle-switch-label" htmlFor="toggleSwitch">
				<span className="toggle-switch-inner" />
				<span className="toggle-switch-switch" />
			</label>
		</div>
	);
};
ToggleSwitch.propTypes = {
	checked: PropTypes.bool.isRequired,
	onChange: PropTypes.func.isRequired,
};

export default ToggleSwitch;
